module.exports = "\r\n.header{\r\n    background-color: #F7F2F2;\r\n    padding:12px;\r\n    font-weight: 650;\r\n    margin:0;\r\n}\r\n\r\n.form-row{\r\n    margin-left:10px;\r\n}\r\n\r\n::ng-deep .ag-theme-balham .ag-header-cell{\r\n    background-color: #f0f9f9;\r\n    font-weight: bold;\r\n    font-size: 14px;\r\n}\r\n\r\n.ag-theme-balham{\r\n    padding:5px 10px;\r\n    border-radius: 5px; \r\n    background:transparent;\r\n}  \r\n \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/household/household.component.css
// module id = ./src/app/household/household.component.css
// module chunks = main